/**
 * Header chip for NYCBS “pharm fill in history” when present on Postgres
 * `auth_on_file.order_tags` (JSON array on the order-auth payload).
 *
 * @module nycbsPharmFillInHistoryHeaderBadge
 */
import { AuthOnFile } from "../../../../../data-model/medicalPaOrdersModel";

/** Canonical tag string written by backend RPA / auth pipelines. */
export const NYCBS_PHARM_FILL_IN_HISTORY_TAG = "NYCBS Pharm Fill in History";

const NORMALIZED_TARGET = NYCBS_PHARM_FILL_IN_HISTORY_TAG.trim().toLowerCase();

/**
 * Returns true when `order_tags` includes the NYCBS pharm fill-in history tag
 * (case-insensitive match on each array entry).
 *
 * @param authOnFile - Auth-on-file subtree from order detail
 * @returns Whether the header should show the NYCBS order tag chip
 */
export function hasNycbsPharmFillInHistoryOrderTag(
  authOnFile?: AuthOnFile | null,
): boolean {
  const tags = authOnFile?.order_tags;
  if (!tags?.length) {
    return false;
  }
  return tags.some(
    (t) =>
      typeof t === "string" && t.trim().toLowerCase() === NORMALIZED_TARGET,
  );
}

/**
 * Rounded-badge colors for {@link BadgeWithIconRounded}, aligned with the
 * “New line of care” care-tag palette in {@link getBadgeDetailsAndIconColorForCareTag}.
 *
 * @returns Background, border, dot, and text colors for the NYCBS order tag
 */
export function getNycbsPharmFillInHistoryBadgeAppearance(): {
  badgeText: string;
  iconColor: string;
  badgeBgColor: string;
  badgeTextColor: string;
  borderColor: string;
} {
  return {
    badgeText: NYCBS_PHARM_FILL_IN_HISTORY_TAG,
    iconColor: "#7c5900",
    badgeBgColor: "#FEF9C3",
    badgeTextColor: "#7c5900",
    borderColor: "#7c5900",
  };
}
